import { Button, DatePicker, Dropdown, Flex, Select } from 'antd';
import React from 'react';
import dayjs from 'dayjs';
import { RangeValue } from 'rc-picker/lib/interface';

import filterOptions, { items } from './utils/filterOptions';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { downloadAnalytics } from './utils/downloadAnalytics';
import { PeriodFilter } from './service/filters.interface';
import {
    selectAnalyticsFilters,
    updateFilters,
} from '../../store/analyticFiltersSlice';
import { getFilterPageTypeOptions } from './utils/filters';
import { formatExtended } from '../../../../shared/contants/date';

const { RangePicker } = DatePicker;

const { ANALYTICS_TYPES, ANALYTICS_PERIODS } = filterOptions;

export const AnalyticsFilters = () => {
    const filters = useAppSelector(selectAnalyticsFilters);
    const dispatch = useAppDispatch();

    const onDownload = async (type: 'csv' | 'xlsx') => {
        await downloadAnalytics(filters, type);
    };

    const onSelectDate = (date: RangeValue<dayjs.Dayjs>) => {
        if (date) {
            dispatch(
                updateFilters({
                    date_from: formatExtended(date[0]),
                    date_to: formatExtended(date[1]),
                })
            );
        }
    };

    const onSelectPeriod = (value: PeriodFilter) => {
        if (value !== 'period') {
            dispatch(
                updateFilters({
                    period: value,
                    date_from: undefined,
                    date_to: undefined,
                })
            );
        } else {
            dispatch(
                updateFilters({
                    period: value,
                })
            );
        }
    };

    return (
        <Flex gap={8}>
            <Select
                style={{ minWidth: '142px' }}
                defaultValue={ANALYTICS_TYPES[0].value}
                options={getFilterPageTypeOptions(ANALYTICS_TYPES, filters)}
                value={filters.viewAnalitycsType}
                onChange={value =>
                    dispatch(
                        updateFilters({
                            viewAnalitycsType: value,
                        })
                    )
                }
            />
            <Select
                style={{ minWidth: '142px' }}
                defaultValue={ANALYTICS_PERIODS[0].value}
                //value={filters.period}
                options={ANALYTICS_PERIODS}
                onChange={onSelectPeriod}
            />
            {filters.period === 'period' && (
                <RangePicker
                    onChange={date => onSelectDate(date)}
                    value={[
                        filters.date_from
                            ? dayjs(filters.date_from, 'DD.MM.YY')
                            : null,
                        filters.date_to
                            ? dayjs(filters.date_to, 'DD.MM.YY')
                            : null,
                    ]}
                    allowClear={false}
                    format='DD.MM.YY'
                />
            )}

            {filters.viewAnalitycsType === 'all' ? (
                <Button onClick={() => onDownload('xlsx')}>
                    Скачать в XLSX
                </Button>
            ) : (
                <Dropdown.Button
                    style={{
                        width: 'auto',
                        marginLeft: '0',
                        justifyContent: 'flex-end',
                    }}
                    onClick={() => onDownload('xlsx')}
                    menu={{ items, onClick: () => onDownload('csv') }}
                >
                    Скачать в XLSX
                </Dropdown.Button>
            )}
        </Flex>
    );
};
